<template>
  <div>
    <div class="ef-ai">
      <header class="ef-ai-header">
        <ChatHeader :config="config" @clear="onClearMessage" :showClear="showClear" />
      </header>
      <div class="ef-ai-content">
        <div class="ef-ai-body scrollbar-width-none">
          <div class="ef-ai-body_inner">
            <ChatMessageList
              ref="chatMessageListRef"
              :botId="bot_id"
              :message-list="messageList"
              :config="config"
              :onboardingInfo="onboarding_info"
              :followUpList="followUpList"
              @send="onMessageListSend"
              @loadMore="getMessageList"
              @click-keywords="clickKeywords"
            />
          </div>
        </div>
        <footer class="ef-ai-footer" v-no-select>
          <div class="shortcut-commands-section" v-if="shortcut_commands.length" v-show="!isSpeaking">
            <div class="shortcut-commands-inner scrollbar-width-none">
              <div class="shortcut-commands-item" v-for="command in shortcut_commands" :key="command.id" @click="onShortcutCommands(command)">
                <span class="shortcut-text">{{command.name}}</span>
              </div>
            </div>
          </div>
          <div class="reserve-a-seat-container" v-show="isSpeaking"></div>
          <div class="footer-section">
            <div class="footer-section-left">
              <div :class="['footer-chat-icon', enterPermissions.permission ? 'available' : 'unavailable']" @click.stop="switchType(enterPermissions.permission)" v-show="!isSpeaking">
                <span :class="['iconfont', enterPermissions.icon]"></span>
              </div>
            </div>
            <div class="footer-section-center">
              <hold-to-talk :disabled.sync="successDone" v-if="voiceInput" @speaking="(value) => isSpeaking = value" @send="sendVoiceMessages"/>
              <div class="footer-chat-input" v-else>
                <input v-model="inputValue" @input="onInput" class="input" type="text" :placeholder="placeholder" @keyup.enter="onSend">
              </div>
            </div>
            <div class="footer-section-right">
              <div class="footer-chat-send" @click="onSend" v-if="!voiceInput">
                <span class="iconfont icon-fabu" :class="{disabled: disabledSend}"></span>
              </div>
            </div>
          </div>
          <!-- 提示语 -->
          <div class="prompt-text" v-if="config.functions && config.functions.includes('5')">{{tip}}</div>
        </footer>
      </div>
    </div>

    <Loading v-model="pageLoading" />
  </div>
</template>

<script>
  import axios from 'axios'
  import Loading from '@/components/Loading'
  import ChatHeader from './components/ChatHeader'
  import { fetchEventSource } from '@microsoft/fetch-event-source';
  import ChatMessageList from './components/ChatMessageList'
  import { mapGetters } from 'vuex'
  import { getOnlineInfo, getConversations, createConversation, getMessageList } from '@/common/http/ai'
  import { getSystemConfig } from '@/common/http/public-server'
  import { gen_uuid } from '@/utils'
  import holdToTalk from './components/common/hold-to-talk';
  import { isPCDevice } from '@/utils/isPCDevice'

  export default {
    components: {
      holdToTalk,
      Loading,
      ChatHeader,
      ChatMessageList
    },
    data() {
      return {
        // aiToken: "Bearer pat_WTn0UAzYZT2NjdwJgUTDvbZF0vPFq5V5Y5gNQ7MEviQqKdd08l078bkNEQpzslWZ",
        voiceInput: false, // 输入方式是否语言
        isSpeaking: false,
        showClear: false,
        messageList: [],
        inputValue: '',
        conversation_id: '', // 暂无会话id
        onboarding_info: {
          prologue: "",
          suggested_questions: [] // 建议问题
        },
        tenantId: null,
        shortcut_commands: [], // 快捷指令
        shortcutCommand: {}, // 当前快捷指令
        conversationList: [],
        followUpList: [],
        pageLoading: false,
        successDone: true, // 是否可发送消息
        last_id: "", // 最后一条消息id
        has_more: true,
        hasCard: false, // 是否卡片类型数据
        config: {}
      }
    },
    computed: {
      ...mapGetters(['bot_id', 'user_id', 'ai_token', 'public_token', 'pathParams', 'lang']),
      disabledSend() {
        return !this.inputValue || !this.successDone
      },
      enterPermissions() {
        if (this.config.functions && this.config.functions.includes('4') && !isPCDevice()) {
          return {
            icon: ['icon-show_yuyin', 'icon-act_jiaobiaobianji'][+this.voiceInput],
            permission: true,
          }
        } else {
          return {
            icon: ['icon-yaoyueqianim'][0],
            permission: false
          }
        }
      },

      // AI生成提示
      tip() {
        const text = {
          cn: '内容由AI生成，仅供参考',
          en: 'Generated by AI; please use as a reference.'
        }[this.lang]
        return text || '内容由AI生成，仅供参考'
      },
      // 输入提示
      placeholder() {
        const text = {
          cn: '在此输入您的问题',
          en: 'Enter your inquiry here'
        }[this.lang]
        return text || '在此输入您的问题'
      }
    },
    created() {
      this.init()

      // 监听窗口变化
      // window.addEventListener('resize', () => {
      //   const _IS_PC_ = window.sessionStorage.getItem('_IS_PC_')
      //   try {
      //     const isPC = JSON.parse(_IS_PC_)
      //     if (isPC !== isPCDevice()) {
      //       window.sessionStorage.setItem('_IS_PC_', isPCDevice())
      //       window.location.reload();
      //     }
      //   } catch (error) {
      //     window.sessionStorage.setItem('_IS_PC_', isPCDevice())
      //     window.location.reload();
      //   }
      // });
    },
    methods: {
      async init(isClear) {
        const { tenantId, user_id, bot_id, owner_type, lang = 'cn' } = this.$route.query
        this.tenantId = tenantId
        this.$store.commit('SET_PATH_PARAMS', this.$route.query)

        this.$store.commit('SEY_AILANG', lang)
        if (tenantId) {
          this.$store.commit('SET_TENANT_ID', tenantId)
        }

        if (bot_id) {
          this.$store.commit('SET_BOT_ID', bot_id)
        }

        if (!this.user_id) {
          this.$store.commit('SET_USER_ID', user_id || gen_uuid())
        }

        this.pageLoading = true

        try {
          if (!this.public_token) {
            await this.$store.dispatch('getPublicServerToken')
          }
          if (!this.ai_token) {
            await this.$store.dispatch('getToken')
          }

          // 获取系统消息 / 以及设备是否可用
          const config = await this.getSystemMessage(bot_id, owner_type)
          // if (config.publishStatus) 判断服务是否可用
          this.config = config
          // 输入框上面的快捷指令获取
          const { shortcut_commands, onboarding_info } = await this.getOnlineInfo()
          this.onboarding_info = onboarding_info
          // 判断快捷指令是否开启
          if (this.config.functions && this.config.functions.includes('3')) {
            this.shortcut_commands = shortcut_commands || []
          }

          const { conversations, has_more } = await this.getConversations()

          if (isClear) {
            this.has_more = has_more
          }

          if (conversations.length) {
            this.conversation_id = conversations[0].id
            this.getMessageList()
          } else {
            const { id: conversation_id } = await this.createConversation()
            this.conversation_id = conversation_id
          }

          this.pageLoading = false
        } catch (error) {
          this.pageLoading = false
          this.$store.dispatch('getToken')
        }
      },
      // 切换文字
      switchType(permission) {
        if(!permission) return
        this.voiceInput = !this.voiceInput
      },
      // 监听语言转文字
      sendVoiceMessages(text) {
        this.inputValue = text
        this.onSend()
      },

      // 获取系统配置详细
      async getSystemMessage(botId, owner_type) {
        return new Promise(async (resolve, reject) => {
          await getSystemConfig({ownerType: owner_type || 1, botId}).then(({data: result}) => {
            if (result.code === 200) {
              resolve(result.data.records[0])
            } else {
              reject(result)
            }
          }).catch((error) => {
            reject(error)
          })
        })
      },

      // 获取快捷指令内容
      getOnlineInfo() {
        return new Promise((resolve, reject) => {
          getOnlineInfo({ bot_id: this.bot_id }).then(res => {
            if (res.data.code === 0) {
              resolve(res.data.data)
            } else {
              reject(res.data)
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      getConversations() {
        return new Promise((resolve, reject) => {
          const params = {
            bot_id: this.bot_id,
            page_num: 1,
            page_size: 1
          }
          getConversations(params).then(res => {
            if (res.data.code === 0) {
              resolve(res.data.data)
            } else {
              reject(res.data)
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      createConversation() {
        return new Promise((resolve, reject) => {
          createConversation({ bot_id: this.bot_id }).then(res => {
            if (res.data.code === 0) {
              resolve(res.data.data)
            } else {
              reject(res.data)
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      formateMessageData(list) {
        const ids = list.map(item => item.chat_id)
        const idLists = Array.from(new Set(ids))

        for (let i = 0; i < list.length; i++) {
          const item = list[i]

          if (idLists.includes(item.chat_id)) {
            if (item.content_type === 'card') {
              if (i > 0) {
                let temp = list[i]
                list[i] = list[i - 1]
                list[i - 1] = temp
              }
            }
          }
        }

        return list
      },
      getMessageList(isLoadMore = false) {
        if (!this.has_more) {
          return
        }

        const params = {
          limit: 50,
          order: 'asc'
        }

        if (isLoadMore) {
          params.after_id = this.last_id
          console.log('load more message request')
        }

        getMessageList(params, { conversation_id: this.conversation_id }).then(res => {
          if (res.data.code === 0) {
            const data = res.data
            const result = data.data.sort((a, b) => a.updated_at - b.updated_at)

            // 翻页
            if (isLoadMore) {
              this.messageList = [...result, ...this.messageList].filter(item => Boolean(item.content))
              const bottom = this.$refs.chatMessageListRef.$refs.messageListRef.scrollHeight

              this.$nextTick(() => {
                // 保持位置不变
                this.$refs.chatMessageListRef.scrollToPosition({ scrollToOffset: { bottom } })
              })
            } else {
              this.messageList = result.filter(item => Boolean(item.content))

              this.$nextTick(() => {
                this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
              })
            }

            if (this.messageList.length) {
              const suggested_questions = this.onboarding_info.suggested_questions || []
              if (this.config.functions && this.config.functions.includes('2')) {
                this.followUpList = suggested_questions.slice(0, 3)
              }
            }

            this.last_id = data.last_id
            this.has_more = data.has_more
          }
        }).catch(err => {
          this.$store.dispatch('getToken')
        })
      },
      onInput() {
        this.inputValue = this.inputValue.replace(/^\s*/, "")
      },
      onSend() {
        if (this.disabledSend) return

        if (this.successDone) this.successDone = false

        const params = {
          bot_id: this.bot_id,
          user_id: this.user_id,
          stream: true,
          // 自定义参数
          custom_variables: {
            ...this.pathParams,
            user_id: this.user_id
          },
          additional_messages: [
            { role: 'user', content_type: 'text', content: this.inputValue }
          ]
        }

        if (Object.keys(this.shortcutCommand).length) {
          params.shortcut_command = {
            command_id: this.shortcutCommand.id
          }
          params.additional_messages = []
        }

        // 用户消息
        this.messageList.push({
          id: "",
          bot_id: "",
          chat_id: "",
          content: this.inputValue,
          content_type: "text",
          meta_data: {},
          reasoning_content: "",
          role: "user",
          type: "question",
        })

        // 清空下方推荐列表
        this.followUpList = []

        this.$nextTick(() => {
          this.inputValue = ""
          this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
        })

        const ctrl = new AbortController();
        fetchEventSource("https://api.coze.cn/v3/chat?conversation_id=" + this.conversation_id, {
          method: 'POST',
          headers: {
            "Authorization": this.ai_token,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(params),
          signal: ctrl.signal,
          async onopen(response) {
            console.log(response, 'onopen')
          },
          onmessage: ({ event, data }) => {
            // event:conversation.message.delta
            // data:{"id":"7477177077628731419","conversation_id":"7476016685812662310","bot_id":"7475763850227941430","role":"assistant","type":"answer","content":"那","content_type":"text","chat_id":"7477177072796925978","section_id":"7476016685812662310"}
            switch(event) {
              case "conversation.chat.created":
                this.handleConversationChatCreated(JSON.parse(data))
                break
              case "conversation.chat.in_progress":
                this.handleConversationChatInProgress(JSON.parse(data))
                break
              case "conversation.message.delta":
                this.handleConversationMessageDelta(JSON.parse(data))
                break
              case "conversation.message.completed":
                this.handleConversationMessageCompleted(JSON.parse(data))
                break
              case "done":
                this.handleConversationDone()
                break
            }
          },
          onerror: error => {
            console.log(error, 'onerror...')
            this.$store.dispatch('getToken')
          },
          onclose() {
            console.log('close...')
          }
        });
      },
      // 关键词介入搜索
      clickKeywords(value) {
        this.inputValue = value
        this.onSend()
      },
      handleConversationChatCreated(data) {

        // 设置用户消息
        const userMessage = this.messageList[this.messageList.length - 1]
        userMessage.id = data.id
        userMessage.chat_id = data.id
        userMessage.conversation_id = data.conversation_id
        userMessage.created_at = data.created_at
        userMessage.section_id = data.section_id


        // 智能体消息
        this.messageList.push({
          id: "",
          bot_id: data.bot_id,
          chat_id: data.id,
          content: "",
          content_type: "text",
          conversation_id: data.conversation_id,
          created_at: data.created_at,
          meta_data: {},
          reasoning_content: "",
          role: "assistant",
          section_id: data.section_id,
          type: "answer",
          loading: true,
        })

        this.$nextTick(() => {
          this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
        })
      },
      handleConversationChatInProgress(data) {
      },
      handleConversationMessageDelta(data) {
        if (data.type !== 'answer' || data.role !== 'assistant') {
          return
        }

        const lastMessage = this.messageList[this.messageList.length - 1]
        // TODO 兼容流式
        if (lastMessage.content_type === 'text' || data.content_type === 'text') {
          if (!lastMessage.id) {
            lastMessage.id = data.id
          }

          lastMessage.content = lastMessage.content += data.content

          this.$nextTick(() => {
            this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
          })
        }
      },
      handleConversationMessageCompleted(data) {
        if (data.type === 'answer') {
          const lastMessage = this.messageList[this.messageList.length - 1]
          if (lastMessage.loading) {
            lastMessage.loading = false
          }

          if (this.hasCard) {
            lastMessage.id = data.id
            lastMessage.chat_id = data.chat_id
            lastMessage.content_type = "card"
            lastMessage.content = data.content
            lastMessage.loading = false

            this.$nextTick(() => {
              this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
            })
          }
        }

        if (data.type === "function_call") {
          try {
            const content = JSON.parse(data.content)
            console.log(content.plugin_name, 'plugin_name')
          } catch (error) {

          }
        } else if (data.type === "tool_response") {
          if (data.content.includes('directly streaming reply')) {
            this.hasCard = true
          }
          // try {
          //   const content = JSON.parse(data.content)
          //   console.log(content, 'tool_response')

          //   // 卡片数据设置
          //   if (content.card_type != undefined) {
          //     // 更改消息
          //     const lastMessage = this.messageList[this.messageList.length - 1]
          //     if (lastMessage) {
          //       lastMessage.id = data.id
          //       lastMessage.chat_id = data.chat_id
          //       lastMessage.content_type = "card"
          //       lastMessage.content = data.content
          //       lastMessage.loading = false

          //       // 创建智能体消息 文本消息
          //       this.messageList.push({
          //         id: "",
          //         bot_id: data.bot_id,
          //         chat_id: data.chat_id,
          //         content: "",
          //         content_type: "text",
          //         conversation_id: "",
          //         created_at: "",
          //         meta_data: {},
          //         reasoning_content: "",
          //         role: "assistant",
          //         section_id: "",
          //         type: "answer",
          //         loading: true
          //       })

          //       this.$nextTick(() => {
          //         this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
          //       })
          //     }
          //   }
          // } catch (error) {
            
          // }
        } else if (data.type === "verbose") {
          try {
            const content = JSON.parse(data.content)
            if (content.msg_type.includes("stream_plugin_finish")) {
              // 创建智能体消息 文本消息
              this.messageList.push({
                id: "",
                bot_id: data.bot_id,
                chat_id: data.chat_id,
                content: "",
                content_type: "text",
                conversation_id: "",
                created_at: "",
                meta_data: {},
                reasoning_content: "",
                role: "assistant",
                section_id: "",
                type: "answer",
                loading: true
              })

              this.$nextTick(() => {
                this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
              })
            }
          } catch (error) {}
        } else if (data.type === "follow_up") {
          if (this.config.functions && this.config.functions.includes('2')) {
            this.followUpList.push(data.content)
          }
          this.$nextTick(() => {
            this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
          })
        }
      },
      handleConversationDone() {
        this.successDone = true
        this.hasCard = false
        this.shortcutCommand = {} // 重置当前快捷指令

        const lastMessage = this.messageList[this.messageList.length - 1]
        
        if (!lastMessage.content) {
          lastMessage.content = '' // 暂无查到数据
          lastMessage.loading = false
          this.messageList.pop()
        }
      },
      async onClearMessage() {
        if (!this.successDone) {
          return
        }

        const { id: conversation_id } = await this.createConversation()
        this.conversation_id = conversation_id
        this.messageList = []

        this.init(true)
      },
      onMessageListSend(text) {
        this.inputValue = text
        this.onSend()
      },
      onShortcutCommands(item) {
        if (!this.successDone) {
          return
        }

        this.inputValue = item.query_template
        this.shortcutCommand = item
        this.onSend()
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (from.path !== '/') {
          vm.showClear = true
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  .ef-ai {
    width: 100%;
    height: 100vh;
    line-height: 1.5em;
    display: flex;
    flex-direction: column;
    /* background: url("https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/chat_bg.png"); */
    background: #EAF1FF;
    background-size: 100% 100%;
  }
  .ef-ai-header {
    width: 100%;
    padding: 14px 16px 10px;
    box-sizing: border-box;
  }
  .ef-ai-content {
    flex: 1 1 auto;
    height: calc(100% - 72px);
    display: flex;
    flex-direction: column;
    background: url("../../assets/ai/ai_bg.webp");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 30px 30px 0 0;
  }

  .ef-ai-body {
    flex: 1 1 auto;
    border-radius: 30px 30px 0 0;
    overflow-y: scroll;
  }
  .ef-ai-body_inner {
    padding: 12px 12px 0;
    box-sizing: border-box;
    height: 100%;
  }
  .ef-ai-footer {
    width: 100%;
    padding: 8px 12px 16px;
    box-sizing: border-box;
    .footer-section {
      width: 100%;
      height: 54px;
      box-sizing: border-box;
      padding: 0 2px;
      background: #ffffff;
      border-radius: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .footer-section-left {
        width: 46px;
        display: flex;
        justify-content: center;
        .footer-chat-icon {
          .iconfont {
            font-size: 20px;
          }
        }
        .footer-chat-icon.available {
          cursor: pointer;
        }
        .footer-chat-icon.unavailable {
          cursor: default;
        }
      }
      .footer-section-center {
        flex: 1;
        display: flex;
        justify-content: center;
        .footer-chat-input {
          flex: 1 1 auto;
          padding: 0;
          box-sizing: border-box;
          .input {
            font-size: 15px;
            width: 100%;
            border: none;
            box-shadow: none;
            outline: none;
          }
        }
      }
      .footer-section-right {
        width: 46px;
        display: flex;
        justify-content: center;
        .footer-chat-send {
          .iconfont {
            font-size: 20px;
            &.disabled{
              color: #b3b8c6;
            }
          }
        }
      }
    }

    .shortcut-commands-section {
      margin-bottom: 14px;
      .shortcut-commands-inner {
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;
        .shortcut-commands-item {
          display: inline-block;
          padding: 8px 14px;
          border-radius: 10px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
          line-height: 1.2;
          &+.shortcut-commands-item {
            margin-left: 12px;
          }
          .shortcut-text {
            vertical-align: middle;
          }
        }
      }
    }
    .reserve-a-seat-container {
      height: 48px;
    }

    .prompt-text {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      padding-top: 8px;
      text-align: center;
    }
  }
</style>